import React from 'react';

export default function Home() {
  return (
    <div className="app">
      <div className="top-text">Dex Music 2025</div>
      <img src="/logo.png" alt="Dex Logo" className="logo" />
      <div className="bottom-text">Dex Music 2025</div>
    </div>
  );
}